module.exports = __webpack_public_path__ + "assets/img/10_5.08c627cb.jpg";